/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.closeConfirmationNotice = () => $('#confirmation-notice').foundation('close');

/*
$(function() {
  $(".ongoing-survey form.new_user_response .form-inputs input, .ongoing-survey form.edit_user_response .form-inputs input").change(function() {
    return $("input.submit", this.form).click();
  });

  return $(".get-started").click(function() {
    const elmt = $('#survey-slider');
    if (elmt) {
      $('html, body').animate({
        scrollTop: elmt.offset().top - 50
      }, 2000);
      return false;
    }
  });
});
*/
initOngoingSurvey = function() {
$(".ongoing-survey form.new_user_response .form-inputs input, .ongoing-survey form.edit_user_response .form-inputs input").change(function() {
    return $("input.submit", this.form).click();
  });
};

initGetStarted = function() {
  $(".get-started").click(function() {
    const elmt = $('#survey-slider');
    if (elmt.length) {
      $('html, body').animate({
        scrollTop: elmt.offset().top - 50
      }, 2000);
      return false;
    }
  });
};


function initHomeOnLoad() {
  if ($(".ongoing-survey form.new_user_response .form-inputs input, .ongoing-survey form.edit_user_response .form-inputs input").length) {
    initOngoingSurvey();
  }
  
  // disable for now - leave intact the link to sign-up form
  //if ($('.get-started').length) {
  //  initGetStarted();
  //}
}

$(initHomeOnLoad);
document.addEventListener('turbo:load', initHomeOnLoad);

